import { render } from "./shop.vue?vue&type=template&id=c45b8ba6&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"

import "./shop.vue?vue&type=style&index=0&id=c45b8ba6&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45b8ba6"]])

export default __exports__